import React from "react"
import type { FC } from "react"

import { Box } from "@mui/material"

import DataAlertPreview from "../dataAlertPreview/dataAlertPreview"

const DataAlert: FC = () => {
  return (
    <Box
      sx={{
        mb: 2,
      }}
    >
      <DataAlertPreview />
    </Box>
  )
}

export default DataAlert
